"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CommaSeparateFormat = CommaSeparateFormat;

var _sortBy = _interopRequireDefault(require("lodash/sortBy"));

var _join = _interopRequireDefault(require("lodash/join"));

var _map = _interopRequireDefault(require("lodash/map"));

function CommaSeparateFormat(params) {
  var value = (0, _sortBy["default"])(params.value, ['displayName', 'string']);
  return (0, _join["default"])((0, _map["default"])(value, function (x) {
    return x.displayName;
  }), ', ');
}